// extracted by mini-css-extract-plugin
export default {"container":"_1vZg8","text":"_1rnmO","amount":"_1Yk5a","error":"_39Igs","button":"_1MXcX"};